function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useMemo, useEffect, useRef, useCallback, Fragment } from 'react';
import { Modal, Icon } from 'mkui-fd';
import Filters from '../Filters';
import { CATEGORY_TYPE, OPTION_TYPE } from '../../contants';
import { buildChoosedItem, clearShoosedByCategory, findItemsInChoosed, resetOptions, findCategory, removeShoosed, getRangeText, getDateRangeText, parseDateRageValue, getAdvanceInitChoosedData } from '../../util';
import { isEmpty } from '../../../_util/stringUtils';
var prefixCls = 'mkui-table-filter';
export default function AdvanceModal(props) {
  var _this = this;

  var visible = props.visible,
      onDismiss = props.onDismiss,
      onClose = props.onClose,
      advanceCategories = props.advanceCategories,
      labelWidth = props.labelWidth,
      onDataFetch = props.onDataFetch,
      choosed = props.choosed,
      dateFormat = props.dateFormat,
      maxPillLength = props.maxPillLength;

  var _useState = useState(function () {
    return getAdvanceInitChoosedData(advanceCategories, choosed);
  }),
      _useState2 = _slicedToArray(_useState, 2),
      currentChoosed = _useState2[0],
      setCurrentChoosed = _useState2[1];

  var _useState3 = useState(advanceCategories),
      _useState4 = _slicedToArray(_useState3, 2),
      categories = _useState4[0],
      setCategories = _useState4[1];

  useEffect(function () {
    setCategories(advanceCategories);
  }, [advanceCategories]);

  var pillChoose = function pillChoose(category, option) {
    // check is exsit
    var choosedFind = findItemsInChoosed(currentChoosed, category.type, category.code, option.code);

    if (choosedFind) {
      return;
    }

    if (category.excluded) {
      clearShoosedByCategory(currentChoosed, category);
      resetOptions(category);
    }

    var shoosedItem = buildChoosedItem(category.name, category.label, category.code, category.type, category.dataField, option.label, option.value, option.code);
    currentChoosed.push(shoosedItem);
    option.active = true;
    setCurrentChoosed(_toConsumableArray(currentChoosed));
    setCategories(_toConsumableArray(categories));
  };

  var pillBatchChoosedHandle = function pillBatchChoosedHandle(category, options) {
    clearShoosedByCategory(currentChoosed, category);
    resetOptions(category);
    options.forEach(function (option) {
      currentChoosed.push(buildChoosedItem(category.name, category.label, category.code, category.type, category.dataField, option.label, option.value, option.code));
      option.active = true;
    });
    setCurrentChoosed(_toConsumableArray(currentChoosed));
    setCategories(_toConsumableArray(categories));
  };

  var rangeChoosed = function rangeChoosed(category, option, value) {
    if (typeof value === 'undefined') {
      return;
    } // update option value


    if (option.value === OPTION_TYPE.CUSTOM_DATE || option.value === OPTION_TYPE.CUSTOM_NUMBER_RANGE || option.value === OPTION_TYPE.CUSTOM_NUMBER) {
      option.customValue = value;
    }

    var showValue = '';
    var searchValue = null;

    if (option.value === OPTION_TYPE.CUSTOM_DATE) {
      value = parseDateRageValue(value);
      showValue = getDateRangeText(value, dateFormat);
      searchValue = value;
    } else if (option.value === OPTION_TYPE.CUSTOM_NUMBER_RANGE) {
      showValue = getRangeText(value);
      searchValue = value;
    } else if (option.value === OPTION_TYPE.CUSTOM_NUMBER) {
      if (option.percent) {
        showValue = "".concat(value, "%");
      } else {
        showValue = value;
      }

      searchValue = value;
    } // check is exsit


    var findShoosed = findItemsInChoosed(currentChoosed, category.type, category.code, option.code);

    if (findShoosed) {
      findShoosed.name = showValue;
      findShoosed.value = value; // return when value is empty

      if (value instanceof Array && (isEmpty(value) || isEmpty(value[0]) && isEmpty(value[1]))) {
        remove(findShoosed);
      } else if (isEmpty(value)) {
        remove(findShoosed);
      }
    } else {
      if (category.excluded) {
        clearShoosedByCategory(currentChoosed, category);
        resetOptions(category);
      }

      var shoosedItem = buildChoosedItem(category.name, category.label, category.code, category.type, category.dataField, showValue, searchValue, option.code);
      currentChoosed.push(shoosedItem);
      option.active = true;
    }

    setCurrentChoosed(_toConsumableArray(currentChoosed));
    setCategories(_toConsumableArray(categories));
  };

  var autoCompleteSelect = function autoCompleteSelect(category, value, text) {
    var findChoosed = findItemsInChoosed(currentChoosed, category.type, category.code);

    if (findChoosed) {
      findChoosed.name = text;
      findChoosed.value = value;
    } else {
      var shoosedItem = buildChoosedItem(category.name, category.label, category.code, category.type, category.dataField, text, value, undefined);
      currentChoosed.push(shoosedItem);
    }

    setCurrentChoosed(_toConsumableArray(currentChoosed));
    setCategories(_toConsumableArray(categories));
  };

  var multipleSearchSearch = function multipleSearchSearch(category, params) {
    var findChoosed = findItemsInChoosed(currentChoosed, category.type, category.code);

    if (findChoosed) {
      findChoosed.name = params.text;
      findChoosed.value = params.value;
    } else {
      var shoosedItem = buildChoosedItem(category.name, category.label, category.code, category.type, params.field, params.text, params.keyword, undefined);
      currentChoosed.push(shoosedItem);
    }

    setCurrentChoosed(_toConsumableArray(currentChoosed));
    setCategories(_toConsumableArray(categories));
  };
  /**
   * 删除单个
   * @param item
   */


  var remove = useCallback(function (item) {
    var category = findCategory(categories, item.categoryCode);

    if (category.type === CATEGORY_TYPE.PILL) {
      var findedOption = category.options.find(function (option) {
        return option.code === item.optionCode;
      });
      findedOption.active = false;

      if (findedOption.value === OPTION_TYPE.CUSTOM_NUMBER_RANGE || findedOption.value === OPTION_TYPE.CUSTOM_DATE) {
        findedOption.customValue = null;
      }
    } else if (category.type === CATEGORY_TYPE.SEARCH || category.type === CATEGORY_TYPE.AUTO_COMPLETE || category.type === CATEGORY_TYPE.MULTIPLE_SEARCH) {
      category.value = '';
    }

    removeShoosed(currentChoosed, item);
    setCurrentChoosed(_toConsumableArray(currentChoosed));
    setCategories(_toConsumableArray(categories));
  }, [currentChoosed, categories]);
  /** *******************handle************************** */

  var removeHandle = useCallback(function (item, e) {
    e.preventDefault();
    e.stopPropagation();
    remove(item);
  }, []); // search

  var inputSearchHandle = function inputSearchHandle(category, value) {
    value = value.trim();
    category.value = value;
    var findChoosed = findItemsInChoosed(currentChoosed, category.type, category.code);

    if (findChoosed) {
      // delete when empty
      if (value === '') {
        _this.remove(findChoosed);
      } else {
        findChoosed.name = value;
        findChoosed.value = value;
        findChoosed.fieldName = category.dataField; // multiple search
      }
    } else {
      // skip when empty
      if (value !== '') {
        var shoosedItem = buildChoosedItem(category.name, category.label, category.code, category.type, category.dataField, value, value, undefined);
        currentChoosed.push(shoosedItem);
      }
    }

    setCurrentChoosed(_toConsumableArray(currentChoosed));
  };

  var inputChangedHandle = function inputChangedHandle(category, e) {
    var value = e.target.value;
    category.value = value;
    setCategories(_toConsumableArray(categories));
  }; // auto complete


  var autoCompleteDataFetchHandle = function autoCompleteDataFetchHandle(category, value) {
    value = value.trim();
    onDataFetch({
      field: category.dataField,
      keyword: value
    }).then(function (data) {
      category.dataSource = data;
      setCategories(_toConsumableArray(categories));
    });
  };

  var autoCompleteSelectHandle = function autoCompleteSelectHandle(category, value, option) {
    var text = option.props.children;
    value = value.trim();
    category.value = value;
    autoCompleteSelect(category, value, text);
  };

  var autoCompleteChangeHandle = function autoCompleteChangeHandle(category, value) {
    category.value = value.trim();
    setCategories(_toConsumableArray(categories));
  }; // multiple search


  var multipleSearchDataFetchHandle = function multipleSearchDataFetchHandle(params) {
    return onDataFetch(params);
  };

  var multipleSearchChangeHandle = function multipleSearchChangeHandle(category, value) {
    category.value = value.trim();
    setCategories(_toConsumableArray(categories));
  };

  var multipleSearchSearchHandle = function multipleSearchSearchHandle(category, params) {
    multipleSearchSearch(category, params);
  }; // pill


  var pillChoosedHandle = useCallback(function (category, option) {
    pillChoose(category, option);
  }, []);

  var rangeChoosedHandle = function rangeChoosedHandle(category, option, value) {
    rangeChoosed(category, option, value);
  };

  var events = useMemo(function () {
    return {
      rangeChoosedHandle: rangeChoosedHandle,
      pillChoosedHandle: pillChoosedHandle,
      inputSearchHandle: inputSearchHandle,
      inputChangedHandle: inputChangedHandle,
      multipleSearchDataFetchHandle: multipleSearchDataFetchHandle,
      multipleSearchSearchHandle: multipleSearchSearchHandle,
      multipleSearchChangeHandle: multipleSearchChangeHandle,
      autoCompleteChangeHandle: autoCompleteChangeHandle,
      autoCompleteSelectHandle: autoCompleteSelectHandle,
      autoCompleteDataFetchHandle: autoCompleteDataFetchHandle,
      pillBatchChoosedHandle: pillBatchChoosedHandle
    };
  }, []);

  var dismissHandle = function dismissHandle() {
    onDismiss();
  };

  var closeHandle = function closeHandle() {
    onClose(currentChoosed);
  };

  var renderChoosedItems = useMemo(function () {
    // optionCode 在非pill类型时，会空
    return currentChoosed.map(function (item) {
      return React.createElement("span", {
        key: "".concat(item.categoryCode, "-").concat(item.optionCode),
        className: "".concat(prefixCls, "-head-info-choosed-item")
      }, React.createElement("span", {
        className: "".concat(prefixCls, "-head-info-choosed-item-label")
      }, item.categoryLabel, ":"), React.createElement("span", {
        className: "".concat(prefixCls, "-head-info-choosed-item-value")
      }, item.name), React.createElement(Icon, {
        type: "close",
        className: "".concat(prefixCls, "-head-info-choosed-item-remove"),
        onClick: function onClick(e) {
          removeHandle(item, e);
        }
      }));
    });
  }, [currentChoosed]);
  var renderHead = useMemo(function () {
    return React.createElement("div", {
      className: "".concat(prefixCls, "-head")
    }, React.createElement("span", {
      className: "".concat(prefixCls, "-head-label"),
      style: {
        width: labelWidth
      }
    }, "\u5F53\u524D\u7B5B\u9009:"), React.createElement("span", {
      className: "".concat(prefixCls, "-head-info")
    }, React.createElement("span", {
      className: "".concat(prefixCls, "-head-info-choosed")
    }, renderChoosedItems)));
  }, [currentChoosed]);
  var renderFilters = useMemo(function () {
    return React.createElement(Filters, _extends({}, events, {
      filterData: categories,
      labelWidth: labelWidth,
      maxPillLength: maxPillLength,
      advanceClickHandle: function advanceClickHandle() {
        _this.advanceClickHandle();
      }
    }));
  }, [categories, currentChoosed]);
  return React.createElement(Modal, {
    title: "\u9AD8\u7EA7\u641C\u7D22",
    visible: visible,
    onCancel: dismissHandle,
    onOk: closeHandle,
    width: 800,
    labelWidth: labelWidth,
    wrapClassName: "".concat(prefixCls, "-advance-modal")
  }, " ", renderHead, renderFilters);
}
//# sourceMappingURL=AdvanceModal.js.map
